<template>
  <a-card :bordered="false">
      <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="授权页面配置">
    <app-warp title='授权'>
      <template #app-content>
        <div class="pic_content" :style="'background-image:url('+info.picdomain+form.bgImage+');background-color:'+form.bgColor">
          <div class="mask s_flex_center">
            <div class="s_bf width85 s_bor5 p-15">
              <p class="m-b-20 fz-15 text-indent2 p-t-10" :style="'color:'+form.textColor">为了向您提供更好的扫码溯源、扫码活动等商品服务，我们需要获取包括但不限于微信头像及昵称在内的信息。</p>
              <div class="width50 height-38 s_flex_center s_bor5 s_mauto" :style="'background-color:'+form.buttonColor+';color:'+form.buttonTextColor">确定</div>
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <a-form ref="ruleForm" :model="form" :rules="rules" class="m-b-20 width100 p-l-20" :label-col="{span:4}" :wrapper-col="{span:20}">
          <div class="moduleContent " style="width:100%;">
            <a-form-item label="页面标题" name='title' :label-col="{span:4}">
              <a-input v-model:value="form.title" placeholder="请输入页面标题" style="width:250px" :maxlength='6'></a-input>
            </a-form-item>
            <a-form-item label="背景图片" :label-col="{span:4}" help="推荐尺寸750*1626px，大小在500kb以内">
              <div class="s_flex_ali">
                <div class="width-104 height-104 s_over">
                  <material :groupType='1' :image="form.bgImage" :max="1" v-on:handlechoose="(data)=>{form.bgImage=data}" v-on:handledel="form.bgImage = ''" />
                </div>
                <a-button type="link" @click='form.bgImage = "/web_base_assets/salesman/storeLogin.png"'>恢复默认值</a-button>
              </div>
            </a-form-item>
            <a-form-item label="页面背景色" help="页面整体背景色">
              <a-input v-model:value="form.bgColor" type="color" style="width:150px" />
              <a-button class="m-l-15" type="primary" @click='form.bgColor = "#ffffff"'>恢复默认值</a-button>
            </a-form-item>
            <a-form-item label="文字颜色">
              <a-input v-model:value="form.textColor" type="color" style="width:150px" />
              <a-button class="m-l-15" type="primary" @click='form.textColor = "#000000"'>恢复默认值</a-button>
            </a-form-item>
            <a-form-item label="按钮颜色">
              <a-input v-model:value="form.buttonColor" type="color" style="width:150px" />
              <a-button class="m-l-15" type="primary" @click='form.buttonColor = "#659FF3"'>恢复默认值</a-button>
            </a-form-item>
            <a-form-item label="按钮文字颜色">
              <a-input v-model:value="form.buttonTextColor" type="color" style="width:150px" />
              <a-button class="m-l-15" type="primary" @click='form.buttonTextColor = "#ffffff"'>恢复默认值</a-button>
            </a-form-item>
          </div>
        </a-form>
        <a-button type="primary" v-has:scanQrcodeConfigSubmit="setOpenSy" class='m-l-20'>
          保存
        </a-button>
      </template>
    </app-warp>
    </a-tab-pane>
          <a-tab-pane :key="2" tab="流程配置" forceRender>
        <SmallSquare content="扫产品码流程" class="m-b-20" />
        <div>
          <!-- <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">
              参与活动时，产品码进入溯源:
            </p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="is_open_sy"
            />
            <a-tooltip placement="right">
              <template #title
                >控制开启智能营销活动时消费者扫码进入的扫码模板路径，“开启”表示需先进入溯源模板，“关闭”表示消费者扫码后直接进入扫码活动模板。
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div> -->
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">非微信环境扫描产品码：</p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="no_wechat_scan"
            />
            <a-tooltip placement="right">
              <template #title
                >1、“开启”表示用户可在不仅限于微信环境内查看商品溯源信息，“关闭”表示用户仅能通过微信扫码溯源；
                <br />
                2、因环境限制，用户使用其它工具扫码，仅能查看商品，无法参加参加营销活动；
                <br />
                3、用户使用其它工具扫码溯源时，系统无法记录扫码用户信息。
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">未授权微信扫描产品码：</p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="no_auth_scan"
            />
            <a-tooltip placement="right">
              <template #title
                >1、“开启”表示用户在微信未授权的情况下可以查看商品溯源信息，“关闭”表示用户在微信未授权的情况下不可以查看商品溯源信息；
                <br />
                2、用户授权失败时，仅能查看商品，无法参加参加营销活动；
                <br />
                3、用户授权失败时，系统无法记录扫码用户信息。
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <!-- <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">引导关注公众号：</p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="product_code_attention_scan"
            />
            <a-tooltip placement="right">
              <template #title
                >1.对于不带公众号前缀的二维码，可以使用该页面引导用户关注公众号<br/>
                2.该配置仅对使用微信扫码的用户生效；非微信环境扫码，不展示该页面
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div> -->
        </div>
        <SmallSquare content="扫物流码流程" class="m-b-20" />
        <div>
          <!-- <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">
              参与活动时，物流码进入箱码页面：
            </p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="logistics_direct_activity"
            />
            <a-tooltip placement="right">
              <template #title
                >控制开启智能营销活动时消费者扫码进入的扫码页面路径，“关闭”表示需先进入箱码扫码页，“开启”表示消费者扫码后直接进入扫码活动模板。</template
              >
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div> -->
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">非微信环境扫描物流码：</p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="no_wechat_scan_logistics_code"
            />
            <a-tooltip placement="right">
              <template #title
                >1、“开启”表示用户可在不仅限于微信环境内查看商品溯源信息，“关闭”表示用户仅能通过微信扫码溯源；
                <br />
                2、因环境限制，用户使用其它工具扫码，仅能查看商品，无法参加参加营销活动；
                <br />
                3、用户使用其它工具扫码溯源时，系统无法记录扫码用户信息。
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">未授权微信扫描物流码：</p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="no_auth_scan_logistics_code"
            />
            <a-tooltip placement="right">
              <template #title
                >开启该功能后，用户未授权（或者不在微信环境），也能扫码进入物流码/箱码页面，但无法正常参与活动</template
              >
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <!-- <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">引导关注公众号</p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="logistics_code_attention_scan"
            />
            <a-tooltip placement="right">
              <template #title
                >
                1.对于不带公众号前缀的二维码，可以使用该页面引导用户关注公众号<br/>
                2.该配置仅对使用微信扫码的用户生效；非微信环境扫码，不展示该页面
                </template
              >
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <div class="m-b-30 ">
            <div class="s_flex_ali">
               <p class="text-ar" style="width: 330px;margin-right:20px">扫小标流水码：</p>
            <a-radio-group v-model:value="scan_small_code_page">
              <a-radio :value="1">打开物流码页面</a-radio>
              <a-radio :value="2">打开防伪码页面</a-radio>
              <a-radio :value="0">不允许打开页面</a-radio>
              <a-tooltip placement="right">
                <template #title>
                  控制小标流水码的扫码结果页<br />
                  1、打开物流码页面，扫描小标流水码时，支持打开箱码配詈页面<br />
                  2、打开防伪码页面，扫描小标流水码时，支持打开溯源信息页面<br />
                  3、不允许打开页面，扫描小标流水码时，不允许跳转其他页面，只显示扫码异常提示信息
                </template>
                <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
              </a-tooltip>
            </a-radio-group>
            </div>
            <div class="m-b-30 s_flex_ali" v-if="scan_small_code_page == 0">
          <p class="text-ar" style="width: 330px;margin-right:20px"></p>
          <a-textarea
            style="width: 350px"
            v-model:value="scan_small_code_page_tip"
            placeholder="请输入提示语"
            showCount
            :maxlength="500"
          ></a-textarea>
        </div>
          </div>
          <div class="m-b-30 ">
            <div class="s_flex_ali">
               <p class="text-ar" style="width: 330px;margin-right:20px">扫小标物流码：</p>
            <a-radio-group v-model:value="scan_small_logistics_code_page">
              <a-radio :value="1">打开物流码页面</a-radio>
              <a-radio :value="3">打开导购积分页</a-radio>
              <a-radio :value="4">打开导购活动页</a-radio>
              <a-radio :value="2">打开防伪码页</a-radio>
              <a-tooltip placement="right">
                <template #title>
                  控制小标物流码的扫码结果页<br/>
                    1、打开物流码页面：扫描小标物流码时，支持打开箱码配置页面。<br/>
                   2、打开防伪码页面：扫描小标物流码时，支持打开溯源信息页面。<br/>
                    3、不允许打开页面：扫描小标物流码时，直接提示异常<br/>
                    4、打开导购活动页：需开通“超级导购”应用；扫描小标物流码时，如果用户身份是导购，就会进入导购活动页；非导购身份就进入物流码页面
                </template>
                <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
              </a-tooltip>
            </a-radio-group>
            </div>
          </div> -->
     
        </div>
        <!-- <SmallSquare content="其他流程设置" class="m-b-20" />

        <div>
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">
              活动结束后，进入活动结束页面：
            </p>
            <a-radio-group v-model:value="act_end_join_act">
              <a-radio :value="1">支持</a-radio>
              <a-radio :value="0">不支持</a-radio>
            </a-radio-group>
            <a-tooltip placement="right">
              <template #title
                >1、支持，活动结束后，消费者扫码支持跳转到活动结束页面<br />
                2、不支持，活动结束后，消费者扫码只能进入对应的商品溯源页面
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">跳转小程序授权手机号：</p>
            <a-radio-group v-model:value="applet_smart_phone">
              <a-radio :value="1">授权手机号</a-radio>
              <a-radio :value="0">不授权</a-radio>
            </a-radio-group>
            <a-tooltip placement="right">
              <template #title>
                1、授权手机号，扫码跳转小程序，进入小程序页面时，会请求获取用户的手机号<br />
                2、不授权手机号，扫码跳转小程序，直接进入对应的页面
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>

          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">扫码跳转小程序：</p>
            <a-radio-group v-model:value="scan_to_jump_miniapp_type">
              <a-radio :value="0">跳转小程序首页</a-radio>
              <a-radio :value="1">跳转指定页面</a-radio>
            </a-radio-group>
            <a-tooltip placement="right">
              <template #title>
                1、跳转小程序首页，消费者扫码跳转小程序，会打开小程序首页<br />
                2、跳转指定页面，消费者扫码跳转小程序会打开指定页面，默认为溯源页面
              </template>
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
          <div class="m-b-30 s_flex_ali">
            <p class="text-ar" style="width: 330px;margin-right:20px">
              未授权用户开奖(国际活动模板):
            </p>
            <a-switch
              :checkedValue="1"
              :unCheckedValue="0"
              v-model:checked="no_auth_join_activity"
            />
            <a-tooltip placement="right">
              <template #title
                >开启的话，没有授权的用户也可以参与扫码活动开奖领奖，但系统无法记录用户信息，扫码活动设置的活动策略也无法对未授权用户生效（该配置需搭配“扫码活动国际版”模板使用）</template
              >
              <QuestionCircleOutlined class="m-l-10 s_c376 fz-16" />
            </a-tooltip>
          </div>
        </div> -->
     

        

        <a-button
          type="primary"
          v-has:scanQrcodeConfigSubmit="setOpenSy"
          :loading="loading"
          style="margin-left: 250px"
        >
          保存
        </a-button>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
  // import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { getAdvertisement, updateAdvertisement } from "@/api/qrcodeActivitys";
  import { iscode } from "@/utils/app";
  import { onMounted, ref } from "@vue/runtime-core";
  import { message } from "ant-design-vue";
  import store from '@/store'
  export default {
    components: {  },
    setup() {
      const activeKey = ref(1);
const is_open_sy = ref(1);
const no_wechat_scan = ref(0);
const no_wechat_scan_logistics_code=ref(0)
const no_auth_scan = ref(0);
const logistics_direct_activity = ref(0);
const no_auth_join_activity = ref(0);
const no_auth_scan_logistics_code = ref(0);
const act_end_join_act = ref(0);
const scan_small_code_page = ref(0);
const scan_small_logistics_code_page = ref(0);
const applet_smart_phone = ref(0);
const scan_to_jump_miniapp_type = ref(0);
const scan_small_code_page_tip = ref("");
const scan_middle_code_page = ref(0);
const scan_big_code_page = ref(0);
const product_code_attention_scan = ref(0);
const logistics_code_attention_scan = ref(0);
const loading = ref(false);
const info = ref(store.state.user.info);
      const form = ref({
        title: "授权",
        bgImage: "",
        bgColor: "#ffffff",
        textColor: '#000000',
        buttonColor: '#659FF3',
        buttonTextColor:"#ffffff"
      });
      const getOpenSy = async () => {
        let result = await getAdvertisement().then((res) => res.data).catch((error) => error);
    if (iscode(result)) {
    result.data.auth_page = result.data.auth_page || {};
    result.data.auth_page.authText =
      result.data.auth_page.authText ||
      "为了向您提供更好的扫码溯源、扫码活动等商品服务，我们需要获取包括但不限于微信头像及昵称在内的信息。";
    form.value = result.data.auth_page;
    is_open_sy.value = result.data.is_open_sy;
    no_wechat_scan.value = result.data.no_wechat_scan;
    no_wechat_scan_logistics_code.value=result.data.no_wechat_scan_logistics_code;
    scan_small_code_page_tip.value = result.data.scan_small_code_page_tip;
    no_auth_scan.value = result.data.no_auth_scan;
    logistics_direct_activity.value = result.data.logistics_direct_activity;
    no_auth_join_activity.value = result.data.no_auth_join_activity;
    no_auth_scan_logistics_code.value = result.data.no_auth_scan_logistics_code;
    act_end_join_act.value = result.data.act_end_join_act;
    scan_small_code_page.value = result.data.scan_small_code_page;
    scan_small_logistics_code_page.value = result.data.scan_small_logistics_code_page;
    scan_middle_code_page.value = result.data.scan_middle_code_page;
    scan_big_code_page.value = result.data.scan_big_code_page;
    applet_smart_phone.value = result.data.applet_smart_phone;
    scan_to_jump_miniapp_type.value = result.data.scan_to_jump_miniapp_type;
    product_code_attention_scan.value = result.data.product_code_attention_scan;
    logistics_code_attention_scan.value = result.data.logistics_code_attention_scan;
  } else {
    message.error(result.msg);
  }
      };
      const setOpenSy = async (e) => {
        let result = await updateAdvertisement({auth_page:form.value,

    no_wechat_scan: no_wechat_scan.value,
    no_wechat_scan_logistics_code:no_wechat_scan_logistics_code.value,
    no_auth_scan: no_auth_scan.value,
    is_open_sy: is_open_sy.value,
    scan_small_code_page_tip: scan_small_code_page_tip.value,
    logistics_direct_activity: logistics_direct_activity.value,
    no_auth_join_activity: no_auth_join_activity.value,
    no_auth_scan_logistics_code: no_auth_scan_logistics_code.value,
    act_end_join_act: act_end_join_act.value,
    scan_small_code_page: scan_small_code_page.value,
    scan_small_logistics_code_page: scan_small_logistics_code_page.value,
    scan_middle_code_page: scan_middle_code_page.value,
    scan_big_code_page: scan_big_code_page.value,
    applet_smart_phone: applet_smart_phone.value,
    scan_to_jump_miniapp_type: scan_to_jump_miniapp_type.value,
    product_code_attention_scan: product_code_attention_scan.value,
    logistics_code_attention_scan: logistics_code_attention_scan.value,

        }).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          message.success(result.message);
          getOpenSy();
        } else {
          message.error(result.message);
        }
      };
      onMounted(() => {
        getOpenSy();
      });
      return {
        info: store.state.user.info,
        form,
        setOpenSy,
        activeKey,
        no_wechat_scan,
        no_wechat_scan_logistics_code,
        no_auth_scan,
        logistics_direct_activity,
        no_auth_join_activity,
        no_auth_scan_logistics_code,
        act_end_join_act,
        scan_small_code_page,
        scan_small_logistics_code_page,
        applet_smart_phone,
        scan_to_jump_miniapp_type,
        scan_small_code_page_tip,
        scan_middle_code_page,
        scan_big_code_page,
        product_code_attention_scan,
        logistics_code_attention_scan,
        loading,
        info
      };
    },
  };
</script>

<style lang="less" scoped>
  .moduleContent {
    min-height: 600px;
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 15px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;
    box-sizing: border-box;
  }

  .pic_content {
    position: relative;
    height: 100%;
    background-position: top;
    background-size: 100%;
    background-repeat: no-repeat;
    .mask{
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: rgba(0,0,0,.5);
    }
  }
</style>
